import React from 'react'
import { Typography, Box } from '@mui/material'
import { FullWidth } from '../Misc/FullWidth'
import styled from '@emotion/styled'
import { colors } from '../../../tokens/colors'
import { storyTypography } from '../../../tokens/typography-storybuilder'

type Props = {
  asset: any
  colorTheme?: string
  backgroundColor?: string
}
export const QuoteBlockPublic = ({
  asset,
  colorTheme,
  backgroundColor,
}: Props) => {
  const quoteBorder = '3px solid ' + `${colorTheme || '#47855c'}`
  if (asset.assetDetails.quote === '' || asset.assetDetails.quote === null) {
    return <span />
  }

  return (
    <FullWidth backgroundColor={backgroundColor}>
      <QuoteBlockBox>
        <BlockWithValue
          style={{ borderTop: quoteBorder, borderBottom: quoteBorder }}
        >
          <PreviewQuoteContainer>
            <QuoteCircle backgroundColor={backgroundColor}>"</QuoteCircle>
            <QuoteBlockText>{asset.assetDetails.quote}</QuoteBlockText>
            <QuoteBlockAuthorText>
              {asset.assetDetails.author}
              <span>{asset.assetDetails.role}</span>
            </QuoteBlockAuthorText>
          </PreviewQuoteContainer>
        </BlockWithValue>
      </QuoteBlockBox>
    </FullWidth>
  )
}

const QuoteBlockBox = styled(Box)`
  margin: 0 auto;
  max-width: 672px;

  @media print {
    max-width: 744px !important;
  }
`
const BlockWithValue = styled(Box)`
  position: relative;
  border-radius: 0;
  padding: 16px 0 8px;
  max-width: 100%;

  border-top: 3px solid #47855c;
  border-bottom: 3px solid #47855c;
  margin-bottom: 0;
`

const PreviewQuoteContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
`
const QuoteBlockText = styled(Typography)`
  ${storyTypography.quote.styles};
  margin: 0 0 12px 0;
`
const QuoteBlockAuthorText = styled(Typography)`
  ${storyTypography.strong.styles}
  margin:  0 0 4px 0;
  & span {
    display: block;
    ${storyTypography.body.styles}
    margin:  0;
  }
`
const QuoteCircle = styled('span')<{ backgroundColor?: string }>`
  font-size: 60px;
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : colors.background.secondaryBackground};
  height: 50px;
  width: 50px;
  line-height: 1.3;
  text-align: center;
  border-radius: 100%;
  top: -26px;
`
